export enum AppKind {
    Page = "page",
}
